import { Media } from '../media/Media'
import { Artist } from '../artist/Artist'
import { ArtistStatus } from '../artist/ArtistStatus'

export class User {
  id?: string | number = undefined
  name?: string = undefined
  firstName?: string = undefined
  lastName?: string = undefined
  email?: string = undefined
  phone?: string = undefined
  lastLogin?: any
  artworksDraftCount?: number
  artworksPublishedCount?: number
  salesCount?: number
  favoritesCount?: number
  subscriptions_count?: number
  purchasesCount?: number
  isArtist?: boolean
  isAdmin?: boolean
  isLatestTermsAccepted?: boolean
  media?: Media | null
  addressline1?: string
  city?: string
  zip?: string
  countryId?: string
  status?: ArtistStatus
  artist_id?: string

  constructor (data: Partial<User> = {}) {
    Object.assign(this, data)
  }

  get artistApproved (): boolean {
    return this.status === 'approved'
  }
}
